module.exports = __webpack_public_path__ + "static/media/ibd_foot3.91497999.png";